export const GAPI_LOADED = 'GAPI_LOADED';
export const GAPI_CHECKING = 'GAPI_CHECKING';
